import { useCallback } from "react"
import { useMutationWithErrorToast } from "@/hooks/useMutationWithErrorToast"
import { getEpisodeOfCareProgressNotesConnectionId } from "@/modules/patients/detail/episode-of-care/lib/get-episode-of-care-connection"
import { Country } from "@/modules/patients/services/__generated__/PatientFragment.graphql"
import {
  Ch_forceDeleteProgressNoteInput,
  chForceDeleteProgressNoteMutation,
} from "@/modules/patients/services/ch/__generated__/chForceDeleteProgressNoteMutation.graphql"
import { chForceDeleteProgressNoteMutation as chMutation } from "@/modules/patients/services/ch/chForceDeleteProgressNoteMutation"
import {
  De_forceDeleteProgressNoteInput,
  deForceDeleteProgressNoteMutation,
} from "@/modules/patients/services/de/__generated__/deForceDeleteProgressNoteMutation.graphql"
import { deForceDeleteProgressNoteMutation as deMutation } from "@/modules/patients/services/de/deForceDeleteProgressNoteMutation"

export const useForceDeleteProgressNoteMutation = (country: Country) => {
  const mutation = country === "CH" ? chMutation : deMutation

  const [commit] = useMutationWithErrorToast<chForceDeleteProgressNoteMutation | deForceDeleteProgressNoteMutation>(
    mutation,
  )

  return useCallback(
    (
      input: De_forceDeleteProgressNoteInput | Ch_forceDeleteProgressNoteInput,
      episodeOfCareId: string | undefined,
      onCompleted?: () => void,
    ) => {
      const connections: string[] = []

      if (episodeOfCareId) {
        connections.push(getEpisodeOfCareProgressNotesConnectionId(episodeOfCareId))
      }

      commit({
        variables: {
          input,
          connections: connections,
        },
        onCompleted(response) {
          const data = response.forceDeleteProgressNote
          if (!data.errors?.length) {
            onCompleted?.()
          }
        },
      })
    },
    [commit],
  )
}
